import React, {useState, useCallback} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Fetch from '../../../Common/Fetch/fetch';
import {trialBalanceType, trialBalanceCategories} from '../../../../util/uiconstants';
import AgGridWrapper from '../../BaseComponentWrappers/AgGridWrapper';
import OARSwitcher from './OARSwitcher';

export default function SwitchableOARTableWrapper(props) {
	const {rightControls, getDataRow, onTypeChange} = props;

	const [activeTab, setActiveTab] = useState(trialBalanceType.Planning);

	const getCategory = (type) => {
        if (type === trialBalanceType.Planning) return trialBalanceCategories.Planning;
        if (type === trialBalanceType.PlanningPriorYear) return trialBalanceCategories.PriorPeriod;
    };

	const fetch = useCallback(() => {
		const extraParams = {
			trialBalanceTypeCategory: getCategory(activeTab)
		};

		return getDataRow(extraParams);
	}, [activeTab]);

	const handleOnTabChange = (type) => {
		setActiveTab(type);
		onTypeChange && onTypeChange(type);
	};

	return (
		<>
			<StyledCustomFirstRowGroup className="StyledCustomFirstRowGroup">
				<section className="LeftSide">
					<OARSwitcher activeTab={activeTab} onTabChange={handleOnTabChange} trialBalanceCall={getDataRow} />
				</section>
				<section className="RightSide">{rightControls && rightControls(activeTab)}</section>
			</StyledCustomFirstRowGroup>
			<Fetch fetch={fetch}>
				<AgGridWrapper {...props} />
			</Fetch>
		</>
	);
}

SwitchableOARTableWrapper.propTypes = {
	rightControls: PropTypes.node,
	getDataRow: PropTypes.func
};

const StyledCustomFirstRowGroup = styled.section`
	display: flex;
	flex-direction: row;
	/* height: var(--px-40); */
	width: 100%;
	margin-bottom: var(--px-20);
	.LeftSide {
		display: inline-flex;
		width: 50%;
	}
	.RightSide {
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
		margin-left: auto;
		width: 45%;
	}
`;
